/**
 * Web: no FAB. Issue reporting FAB is mobile-only; web bundle does not include the real MovableFAB.
 */
export const MovableFAB = () => null;
